import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  SkeletonDisplayText,
  SkeletonBodyText,
} from "@shopify/polaris";
import DataTableSkeleton from "components/datatable/DataTableSkeleton";

const SidebarCard = ({ lines }: { lines: number }) => (
  <Card roundedAbove="sm">
    <BlockStack gap="300">
      <SkeletonDisplayText size="small" />
      <SkeletonBodyText lines={lines} />
    </BlockStack>
  </Card>
);

/**
 * Loading placeholder for the asset detail page. Mirrors the real two-column
 * layout — comments + assignment-history table on the left, asset details and
 * the assign/sign/return flow cards on the right — so the page doesn't jump
 * once the asset loads, instead of a bare full-page spinner.
 */
export default function AssetViewSkeleton() {
  return (
    <SkeletonPage fullWidth backAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* comments */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
            {/* assignment history table */}
            <Card roundedAbove="sm">
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <DataTableSkeleton rows={5} columns={5} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            {/* asset details */}
            <SidebarCard lines={10} />
            {/* assign / signature / return flow cards */}
            <SidebarCard lines={2} />
            <SidebarCard lines={2} />
            <SidebarCard lines={2} />
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
